module.exports = __webpack_public_path__ + "images/82cafbe80629a9367627cd9a40c8182a.jpg";